import { toast } from "sonner";
import { createFixedConfig, updateFixedConfig } from "./api";
import { useMutation } from "@tanstack/react-query";
import { invalidateJobQueries } from "components/job/queries";

export function useCreateFixedConfig() {
  return useMutation({
    mutationFn: async ({ jobId, values }) => {
      return await createFixedConfig({ jobId, values });
    },
    onSuccess: () => {
      toast.success("Config created successfully");
      invalidateJobQueries();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to create config");
      console.error(err);
    },
  });
}

export function useUpdateFixedConfig() {
  return useMutation({
    mutationFn: async ({ id, values }) => {
      return await updateFixedConfig({ id, values });
    },
    onSuccess: () => {
      toast.success("Config updated successfully");
      invalidateJobQueries();
    },
    onError: (err) => {
      toast.error(err.message || "Failed to update config");
      console.error(err);
    },
  });
}
